/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Callback_Error_LabelInputs */

const en_callback_error_label = /** @type {(inputs: Callback_Error_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const fr_callback_error_label = /** @type {(inputs: Callback_Error_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur : ${i?.message}`)
};

const ms_sg2_callback_error_label = /** @type {(inputs: Callback_Error_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ralat: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error: {message}" |
*
* @param {Callback_Error_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const callback_error_label = /** @type {((inputs: Callback_Error_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Callback_Error_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_callback_error_label(inputs)
	if (locale === "fr") return fr_callback_error_label(inputs)
	return ms_sg2_callback_error_label(inputs)
});